"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _city = _interopRequireDefault(require("./city.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable global-require */
var _default = {
  className: _style["default"].background,
  assets: [_city["default"]],
  imageUrl: _city["default"]
};
exports["default"] = _default;